<!-- <ngb-accordion #acc="ngbAccordion">
    <ngb-panel id="toggle-panel">
        <ng-template ngbPanelTitle>{{ 'CONDITIONS_FILTER.SERCH_FILTER' | translate }}<i class="bi bi-arrow-down-up"></i></ng-template>
        <ng-template ngbPanelContent>

            <div class="row">
                <div class="col-2">
                    <div class="form-group">
                        <label class="filter-label" for="legal_form_id">{{ 'CONDITIONS_FILTER.BOOLEAN_OPERATOR' | translate }}:</label>
                        <ng-select id="attribute_id" class="custom" notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name"
                            bindValue="id" [multiple]="false" [items]="operatorsForCondition"
                            [(ngModel)]="selectedOperatorsForCondition" [clearable]="false" appendTo="body">
                        </ng-select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-8">
                    <form class="form"  #f="ngForm" [formGroup]="form" autocomplete="off">

                        <div formArrayName="filters">

                            <div *ngFor="let item of form.get('filters')['controls']; let i = index;">

                                <div class="row" [formGroupName]="i">

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}:</label>
                                            <ng-select 
                                            id="attribute_id" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAR' | translate }}" 
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name"
                                            formControlName="attribute_id" 
                                            [items]="attributes"
                                            groupBy="attribute_group_name" 
                                            [dropdownPosition]="'bottom'"
                                            [selectOnTab]="true">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div title="{{item.name}}">{{item.name}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-3">
                                        <div class="form-group">
                                            <label class="filter-label" for="legal_form_id"> {{ 'CONDITIONS_FILTER.OPERATOR' | translate }}:</label>
                                            <ng-select 
                                            id="attribute_id" 
                                            class="custom" 
                                            notFoundText="{{ 'NO_DATA' | translate }}"
                                            bindLabel="name" 
                                            bindValue="id" 
                                            formControlName="operator"
                                            [multiple]="false" 
                                            [clearable]="false" 
                                            [items]="operators[i]"
                                            >
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-3">

                                        <label class="filter-label" for="legal_form_id"> {{ 'VALUE' | translate }}:</label>
                                            <div>
                                                <tag-input
                                                    *ngIf="valueFieldType[i] == 'input'"
                                                    formControlName="values" 
                                                    [modelAsStrings]="true"
                                                    placeholder="{{ 'ADD_VALUE' | translate }}" 
                                                    secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}"
                                                    addOnBlur="true" 
                                                    addOnPaste="true"
                                                    [disable]="!disableValue[i]"
                                                    [pasteSplitPattern]=splitPattern[i]
                                                    >
                                                    <div *ngIf="!isDate[i] && sizeTg" class="">
                                                        
                                                            <select class="inputClass">
                                                                <option *ngFor="let item of convertSize" [value]="item.value" [selected]="item.default">{{ item.value }}</option>
                                                            </select>
                                                    </div>
                                                </tag-input>
                                            </div>

                                        <div *ngIf="valueFieldType[i] == 'size'">
                                            <input 
                                                class="form-control"
                                                type="number"
                                                formControlName="values"
                                                [readonly]="!disableValue[i]"
                                                 />
                                        </div>



                                        <div class="input-group" *ngIf="valueFieldType[i] == 'date'">
                                            <input 
                                            readonly="true"
                                            class="form-control"
                                            formControlName="values"
                                            id="date" 
                                            ngbDatepicker
                                            [minDate]="minDate"
                                            #dS="ngbDatepicker"
                                            [placement]="placement">
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary calendar" (click)="dS.toggle()" type="button">
                                                        <i class="bi bi-calendar-event"></i>
                                                    </button>
                                                </div>
                                        </div>

                                        <div class="form-group" *ngIf="valueFieldType[i] == 'combobox'">
                                            <ng-select 
                                            id="value" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAN' | translate }}" 
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name"
                                            bindValue="id"
                                            [multiple]="true"
                                            formControlName="values" 
                                            [items]="references[i]"
                                            groupBy="attribute_group_name" 
                                            appendTo="body"
                                            [selectOnTab]="true"
                                            [readonly]="!disableValue[i]"
                                            [dropdownPosition]="'bottom'"
                                            >
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div title="{{item.name}}">{{item.name}}</div>
                                                </ng-template>

                                            </ng-select>
                                        </div>

                                    </div>

                                    <div class="col-1" *ngIf="valueFieldType[i] == 'size'">
                                        <div class="form-group">
                                            <label class="filter-label" for="convertation_format"> Формат: </label>
                                            <select class="inputClass" formControlName="sizeType">
                                                <option *ngFor="let item of convertSize"  [value]="item.value" [selected]="item.default">{{ item.value }}</option>
                                            </select>
                                            <ng-select id="size_field" class="custom" notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="value"
                                                bindValue="value" [multiple]="false" [items]="convertSize"
                                                [clearable]="false" appendTo="body">
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="col-1 remove-filter-field" *ngIf="form.get('filters').value.length > 1">
                                            <button type="button" class="btn btn-danger" (click)="removeFilterField(i)">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                    </div>                                
                                </div>

                            </div>                            
                        </div>


                    </form>
                    
                </div>


                <div class="col-4">
                    <div class="filter-buttons">

                            <button type="button" class="btn btn-primary btn-sm" (click)="addFilterFields()">
                                <i class="bi bi-plus-circle" [ngClass]="{'mr-1': !settingVue}"></i> <span *ngIf="!settingVue" [ngClass]="{'sm-btn': !settingVue}">{{ 'CONDITIONS_FILTER.ADD_FILTER' | translate }}</span>
                            </button>

 
                            <button class="btn btn-primary btn-sm"  (click)="applyFilterData(); acc.toggle('toggle-panel') "[disabled]="form.invalid"> 
                                <span *ngIf="!settingVue">{{ 'APPLY' | translate }}</span> 
                                <span *ngIf="settingVue"><i class="bi bi-check-circle"></i> </span>
                            </button>


                            <button class="btn btn-outline btn-sm" (click)="resetFilterData(i)"> 
                                <span *ngIf="!settingVue">{{ 'RESET' | translate }}</span>
                                <span *ngIf="settingVue"><i class="bi bi-arrow-repeat"></i> </span>
                            </button>

                    </div>
                </div>
            </div>

            <div class="wrapper-filter col-8">

                <div class="filter-mainItem">

                    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                        <div formArrayName="filters">

                            <div *ngFor="let item of form.get('filters')['controls']; let i = index;">

                                <div class="row wrapper-filter_items" [formGroupName]="i">

                                    <div class="filter-item">
                                        <div class="form-group">
                                            <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}:</label>
                                            <ng-select 
                                            id="attribute_id" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAN' | translate }}" 
                                            (click)="onListenerAttribute(i)"
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name"
                                            formControlName="attribute_id" 
                                            [items]="attributes"
                                            groupBy="attribute_group_name" 
                                            appendTo="body"
                                            [selectOnTab]="true">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div title="{{item.name}}">{{item.name}}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    </div>

                                    <div class="filter-item">
                                        <div class="form-group">
                                            <label class="filter-label" for="legal_form_id"> {{ 'CONDITIONS_FILTER.OPERATOR' | translate }}:</label>
                                            <ng-select 
                                            id="attribute_id" 
                                            class="custom" notFoundText="{{ 'NO_DATA' | translate }}"
                                            bindLabel="name" 
                                            bindValue="id" 
                                            formControlName="operator"
                                            [multiple]="false" 
                                            [clearable]="false" 
                                            [items]="operators[i]"
                                            appendTo="body">
                                            </ng-select>
                                        </div>
                                    </div>


                                    <div class="filter-item">
                                        <div class="form-group">
                                           
                                            <label class="filter-label" for="legal_form_id"> {{ 'VALUE' | translate }}:</label>
                                                <tag-input
                                                class="bootstrap"
                                                *ngIf="!isDate[i]"
                                                formControlName="value" 
                                                [modelAsStrings]="true"
                                                placeholder="{{ 'ADD_VALUE' | translate }}" 
                                                secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}"
                                                addOnBlur="true" 
                                                addOnPaste="true"
                                                [pasteSplitPattern]=splitPattern[i]>
                                                </tag-input>

                                            <div class="input-group" *ngIf="isDate[i]">
                                                <input class="form-control" formControlName="value" id="date" ngbDatepicker #dS="ngbDatepicker" [placement]="placement">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar" (click)="dS.toggle()" type="button">
                                                            <i class="bi bi-calendar-event"></i>
                                                        </button>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-1 d-flex justify-content-center">

                                            <div class="remove-filter-field" *ngIf="form.get('filters').value.length > 1">
                                                <button type="button" class="btn btn-danger" (click)="removeFilterField(i)">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </div>

                                    <div class="filter-item remove-filter-field ml-3" *ngIf="form.get('filters').value.length > 1">
                                        <button type="button" class="btn btn-danger" (click)="removeFilterField(i)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="col-4 filter-buttons">

                        <button type="button" class="btn btn-primary btn-sm" (click)="addFilterFields()">
                            <i class="bi bi-plus-circle" [ngClass]="{'mr-1': !settingVue}"></i> <span *ngIf="!settingVue">{{ 'CONDITIONS_FILTER.ADD_FILTER' | translate }}</span>
                        </button>

                        <button class="btn btn-primary btn-sm" [ngClass]="{'apply-btn apply-btn:focus': settingVue}" (click)="applyFilterData();acc.toggle('toggle-panel') "[disabled]="form.invalid"> 
                            <span *ngIf="!settingVue">{{ 'APPLY' | translate }}</span> 
                            <span *ngIf="settingVue"><i class="bi bi-check-circle"></i> </span>
                        </button>

                        <button class="btn btn-outline btn-sm" (click)="resetFilterData()"> 
                            <span *ngIf="!settingVue">{{ 'RESET' | translate }}</span>
                            <span *ngIf="settingVue"><i class="bi bi-arrow-repeat"></i> </span>
                        </button>

                </div>

            </div>

        </ng-template>
    </ngb-panel>
</ngb-accordion> -->

<div class="row">
    <div class="col-12 card-inner">
        <div class="card" [ngClass]="{'settingsVue': settingVue}">

            <div class="card-header" [ngClass]="{'settingsVue': settingVue}" *ngIf="!settingVue">
                <div class="card-header_title" >{{ 'Фильтр для поиска' | translate }}</div>
                <div class="tools">

                    <!-- <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()"
                            (click)="deleteSelected()">
                            <i class="bi bi bi-trash"></i> Удалить выбранное
                        </button> -->

                    <!-- <button type="button" class="btn btn-primary btn-sm" (click)="onTopLevelCreate()">
                            <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                        </button> -->

                        <button type="button" class="close" aria-label="Close" (click)="onClose()">
                            <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                        </button>
                </div>
            </div>

            <div class="">
                <div class="">

                    <!-- <div *ngIf="settingVue" class="custom-control custom-checkbox" style="margin-bottom: 15px;">

                        <label class="custom-control-label" for="access_to_all_products"> Дать доступ ко всем товарам </label>

                        <input class="custom-control-input" type="checkbox" name="access_to_all_products" id="access_to_all_products" [(ngModel)]="accessToAllProducts" [disabled]="form.valid">
                    </div> -->

                    <div  *ngIf="settingVue" class="custom-control custom-checkbox access-check-box">
                        <input class="custom-control-input" type="checkbox" name="access_to_all_products" id="access_to_all_products" (click)="setToDedault()" [(ngModel)]="accessToAllProducts">
                        <label class="custom-control-label" for="access_to_all_products">Дать доступ ко всем товарам</label>
                    </div>

                    <div class="operators-forCondition">
                        <label class="input-radio_titel">
                            Логический оператор
                        </label>
                        <div class="input-radio_inner">
                            <ng-container *ngFor="let operator of operatorsForCondition">
                            <label class="input-radio">
                              <input 
                              type="radio" 
                              [value]="operator.id"
                              [(ngModel)]="selectedOperatorsForCondition"
                              checked
                              name="operator.name" />{{operator.name}}
                              <span class="radio"></span>
                            </label>
                            </ng-container>
                        </div>
                    </div>
                   
                    <div class="filter-fields_inner" [ngClass]="{'settingsVue': settingVue}">
                        <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

                            <div formArrayName="filters">

                                <div *ngFor="let item of form.get('filters')['controls']; let i = index;">

                                    <div class="filter-fields" [formGroupName]="i">

                                        <div class="attribute-field" [ngClass]="{'settingsVue': settingVue}">
                                            <div class="form-group">
                                                <label class="filter-label" for="attribute_id"> {{ 'ATTRIBUTE' | translate }}</label>
                                                <ng-select id="attribute_id" class="custom"
                                                    clearAllText="{{ 'CLEAR' | translate }}"
                                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                                    
                                                    bindLabel="name"
                                                    formControlName="attribute_id" 
                                                    [items]="attributes"
                                                    groupBy="attr_group_name" 
                                                    [dropdownPosition]="'bottom'"
                                                    [selectOnTab]="true"
                                                    placeholder="Выберите из списка">
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <div title="{{item.name}}">{{item.name}}</div>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="operator-field" [ngClass]="{'settingsVue': settingVue}">
                                            <div class="form-group">
                                                <label class="filter-label" for="legal_form_id"> {{
                                                    'CONDITIONS_FILTER.OPERATOR' | translate }}</label>
                                                <ng-select id="attribute_id" class="custom"
                                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                                    placeholder="Выберите из списка"bindLabel="name"
                                                    bindValue="id" formControlName="operator" [multiple]="false"
                                                    [clearable]="false" [items]="operators[i]">
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="value-field" [ngClass]="{'settingsVue': settingVue}">

                                            <label class="filter-label" for="legal_form_id"> {{ 'VALUE' | translate }}</label>
                                            <div>
                                                <tag-input *ngIf="valueFieldType[i] == 'input'" formControlName="values"
                                                    [modelAsStrings]="true" 
                                                    placeholder="{{ 'ADD_VALUE' | translate }}"
                                                    secondaryPlaceholder="{{ 'INTER_VALUE' | translate }}"
                                                    addOnBlur="true" 
                                                    addOnPaste="true" 
                                                    [disable]="!disableValue[i]"
                                                    [pasteSplitPattern]=splitPattern[i]>
                                                </tag-input>
                                            </div>

                                            <div *ngIf="valueFieldType[i] == 'size'">
                                                <input class="form-control" type="number" formControlName="values"
                                                    [readonly]="!disableValue[i]" />
                                            </div>



                                            <div class="input-group" *ngIf="valueFieldType[i] == 'date'">
                                                <input readonly="true" class="form-control" 
                                                formControlName="values"
                                                id="date" 
                                                ngbDatepicker 
                                                [minDate]="minDate" 
                                                #dS="ngbDatepicker"
                                                [placement]="placement">
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary calendar"
                                                        (click)="dS.toggle()" type="button">
                                                        <i class="bi bi-calendar-event"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="form-group" *ngIf="valueFieldType[i] == 'combobox'">
                                                <ng-select id="value" class="custom"
                                                    clearAllText="{{ 'CLEAN' | translate }}"
                                                    notFoundText="{{ 'NO_DATA' | translate }}" 
                                                    bindLabel="name"
                                                    bindValue="id" 
                                                    [multiple]="true" 
                                                    formControlName="values"
                                                    [items]="references[i]" 
                                                    groupBy="attribute_group_name"
                                                    appendTo="body" 
                                                    [selectOnTab]="true" 
                                                    [readonly]="!disableValue[i]"
                                                    [dropdownPosition]="'bottom'"
                                                    placeholder="Выберите из списка">
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <div title="{{item.name}}">{{item.name}}</div>
                                                    </ng-template>

                                                </ng-select>
                                            </div>

                                        </div>

                                        <div class="tools-feilds" [ngClass]="{'settingsVue': settingVue}">
                                            <div class="size_inner">
                                                <div *ngIf="valueFieldType[i] == 'size'">
                                                    <div class="form-group size-field">
                                                        <label class="filter-label" for="convertation_format"> Формат
                                                        </label>
                                                        <select class="inputClass" formControlName="sizeType">
                                                            <option *ngFor="let item of convertSize"
                                                                [value]="item.value" [selected]="item.default">{{
                                                                item.value }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tools-inner">
                                                <div class="remove-filter-field"
                                                    *ngIf="form.get('filters').value.length > 1">
                                                    <button type="button" class="btn btn-danger btn-sm"
                                                        (click)="removeFilterField(i)">
                                                        <!-- <i class="bi bi-trash"></i> -->
                                                        <svg-icon src="/assets/images/icons/trash-can.svg" [stretch]="true"
                                                        [svgStyle]="{'width.px':24, 'height.px':24}"></svg-icon>
                                                    </button>
                                                </div>

                                                <div class="add-field">
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="addFilterFields()">
                                                        <!-- <i class="bi bi-plus-circle"></i> -->
                                                        <svg-icon class="icon" src="/assets/images/icons/add.svg" [stretch]="true"
                                                        [svgStyle]="{'width.px':24, 'height.px':24}"></svg-icon>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>


                        </form>

                    </div>
                </div>


                <div class="filter-buttons">
<!-- 
                    <button *ngIf="settingVue" class="btn btn-light btn-sm" (click)="setToDedault()">
                        <span>Применить ко всем товарам по умолчанию</span>
                    </button> -->

                    <button class="btn btn-light btn-sm" (click)="resetFilterData()"> 
                        <span>{{ 'RESET' | translate }}</span>
                        <!-- <span *ngIf="settingVue"><i class="bi bi-arrow-repeat"></i> </span> -->
                    </button>

                    <button class="btn btn-primary btn-sm" (click)="applyFilterData();onClose()" [disabled]="form.invalid">
                        <span>{{ 'APPLY' | translate }}</span>
                        <!-- <span *ngIf="settingVue"><i class="bi bi-check-circle"></i> </span> -->
                    </button>
                </div>
            </div>
        </div>
    </div>